import { configureStore, combineSlices } from "@reduxjs/toolkit";

import { articlePostsSlice } from "./articles-posts.slice";

const rootReducer = combineSlices(articlePostsSlice);

export const store = configureStore({
    reducer: rootReducer,
});
